var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isShow)?_c('ThirdBind',{attrs:{"argument":_vm.argument},on:{"close":_vm.handelClose}}):_vm._e(),_vm._v(" "),(_vm.showThirdLoginBindPhone)?_c('ThirdLoginBindPhone',{attrs:{"argument":_vm.bindPhoneArgument},on:{"close":_vm.handelCloseBindPhone}}):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f73aa87c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/passport/auth.vue
// module id = null
// module chunks = 